/*------------------------------------------------------------------
Import external modules
------------------------------------------------------------------*/

import VideoEmbed from '../classes/video-embed';
import BackgroundVideo from '../classes/background-video';
// import { tns } from 'tiny-slider/src/tiny-slider';

/*------------------------------------------------------------------
Banner Slider
------------------------------------------------------------------*/

console.log('Banner Slider');

// Find the banner & slider
const banner = document.querySelector('.js-banner');
const slider = banner.querySelector('.js-banner__slider');
const slides = [...slider.children];
const controls = banner.querySelector('.js-banner__controls');
const nav = [...controls.children];
// Pair the nav with the slides
const pairs = [];

let autoplay = null;
let slideIndex = 0;

// Store our videos here
const videos = [];

const loadVideo = (index = 0) => {
  if (window.innerWidth >= 1024) {
    videos.forEach((video) => {
      if (video.container == slides[index]) {
        video.holder.appendChild(video.iframe.element);
        video.iframe.resize();
      } else {
        try {
          video.iframe.element.classList.remove('video-loaded');
          video.holder.removeChild(video.iframe.element);
        } catch (err) { }
      }
    });
  }
}

const goto = (index) => {
  // get the item and button from the pair with this index
  const { item, button } = pairs[index];

  slideIndex = index;

  // If this is the active slide, do nothing
  if (slider.children[0] === item) return;

  // To start with, we need to move everything before this slide up and out of view
  // Let's find the slides before this one
  const items = [...slider.children];
  const currentIndex = items.indexOf(item);
  const previousIndex = items.indexOf(items[0]);
  const difference = Math.abs(currentIndex - previousIndex);
  const prevSlides = items.slice(0, difference);

  // Remove the hide class from this item
  item.classList.remove('custom-slider-item--hide');

  // Add a hide class to the previous slides
  prevSlides.forEach((slide) => {
    slide.classList.add('custom-slider-item--hide');
  });

  setTimeout(() => {
    // Move the item to the first position
    slider.insertBefore(item, slider.children[0]);

    // Set the active class on the item
    item.classList.add('custom-slider-item--active');

    setTimeout(() => {
      item.classList.add('custom-slider-item--front');
    }, 1000);

    setTimeout(() => {
      // Remove the hide class from the previous slides
      prevSlides.forEach((slide) => {
        // Put this slide at the bottom of the stack
        slider.appendChild(slide);

        setTimeout(() => {
          slide.classList.remove('custom-slider-item--hide');
        }, 50);
      });
    });
  }, 500);

  loadVideo(index);

  pairs.forEach((pair) => {
    pair.item.classList.remove('custom-slider-item--front');
    pair.item.classList.toggle('custom-slider-item--active', pair.item === item);
    pair.button.classList.toggle('custom-slider-nav--active', pair.button === button);
  });
};

// Create a pair for each slide
slides.forEach((slide, index) => {
  pairs.push({
    index: index,
    item: slide,
    button: nav[index],
  });
});

pairs.forEach((pair, i) => {
  // Grab the item and the button
  const { index, item, button } = pair;

  // When the button is clicked, grab the item, and move it to the first position in the slider container
  button.addEventListener('click', () => {
    goto(index);
    clearInterval(autoplay);
  });

  item.classList.add('custom-slider-item');
  button.classList.add('custom-slider-nav');

  if (i === 0) {
    item.classList.add('custom-slider-item--front');
    item.classList.add('custom-slider-item--active');
    button.classList.add('custom-slider-nav--active');
  }
});

slides.forEach((slide, index) => {
  // // Find a video if there is one
  const video = slide.querySelector('[data-background-video]') || false;

  // If we have a video
  if (video) {
    // Create a video embed
    const embed = new VideoEmbed(video.getAttribute('data-background-video'), { mute: 1, loop: 1, });

    const data = {
      container: slide,
      holder: video,
      index: index,
      iframe: new BackgroundVideo(embed.iframe),
    };

    const observer = new ResizeObserver(() => data.iframe.resize());

    observer.observe(video);
    videos.push(data);

    if (index === 0) loadVideo(index);
  }
});

if (slides.length > 1) {
  autoplay = setInterval(() => {
    let targetIndex = (slideIndex < slides.length - 1) ? slideIndex + 1 : 0;
    goto(targetIndex);
  }, 10000);
}

// slider.tns.events.on('indexChanged', (data) => loadVideo(data.index));
